import React from 'react';
import { siteInfo } from '../data/mockData';

const Header = () => {
  return (
    <header className="header-section">
      <div className="header-logo-container">
        <img
          src={siteInfo.logoUrl}
          alt={siteInfo.name}
          className="header-logo"
        />
      </div>
    </header>
  );
};

export default Header;
